import { createRouter, createWebHashHistory } from 'vue-router'
import WebApp from '../views/WebApp.vue'
import Login from '../views/Login.vue'
import Profile from '../views/Profile.vue'
import AboutView from '../views/AboutView.vue'
import store from '../store/index'
import FlashCards from '../views/FlashCards.vue'
import Results from '../views/Results.vue'
import QuestionsAnswers from '../views/QuestionsAnswers.vue'
import QuestionsResults from '../views/QuestionsResults.vue'
import QuestionsResultsSup from '../views/QuestionsResultsSup.vue'
import Questions from '../views/Questions.vue'
import QuestionsUpdated from '../views/QuestionsUpdated.vue'
import QuestionsUpdatedSup from '../views/QuestionsUpdatedSup.vue'
import QuestionsQuiz from '../views/QuestionsQuiz.vue'
import QuestionsChallenge from '../views/QuestionsChallenge.vue'
import QuestionsQuizChallenge from '../views/QuestionsQuizChallenge.vue'
import QuestionsQuizSimulado from '@/views/QuestionsQuizSimulado.vue'
import QuestionsQuizSimuladoPratico from '@/views/QuestionsQuizSimuladoPratico.vue'
import QuizResults from '@/views/QuizResults.vue'
import QuestionsAnswersChallenge from '../views/QuestionsAnswersChallenge.vue'
import QuestionsSimulado from '../views/QuestionsSimulado.vue'
import SimuladosResults from '@/views/SimuladosResults.vue'
import TECMSimuladosLanding from '@/views/TECMSimuladosLanding.vue'
import TECMQuestionsSimuladoLanding from '@/views/TECMQuestionsSimuladoLanding.vue'
import TECMQuestionQuizSimuladoLanding from '@/views/TECMQuestionQuizSimuladoLanding.vue'
import QuestionsAdmin from '../views/QuestionsAdmin.vue'
import ConsolidatedMetrics from '../views/ConsolidatedMetrics.vue'
import Decks from '../views/Decks.vue'
import DecksV2 from '../views/DecksV2.vue'
import ResultsV2 from '../views/ResultsV2.vue'
import FlashCardsV2 from '../views/FlashCardsV2.vue'

const authGuard = (to, from, next) => {
  if (store.state.user) {
    // Se o usuário estiver autenticado, permita a navegação
    next()
  } else {
    // Se o usuário não estiver autenticado, redirecione para a página de login,
    // mas salve a rota para a qual ele estava tentando acessar para redirecioná-lo
    // de volta após o login bem-sucedido
    next({
      path: '/',
      query: { redirect: to.fullPath }
    })
  }
}

const routes = [
  {
    path: '/tecm-sim-exp',
    name: 'TECM_SimuladosLanding',
    component: TECMSimuladosLanding,
  },
  {
    path: '/tecm-sim-exp-questions',
    name: 'TECM_QuestionsSimuladoLanding',
    component: TECMQuestionsSimuladoLanding,
    // Desativado temporariamente para testes
    beforeEnter: (to, from, next) => {
      if (store.state.hasSubmittedLead) {
        next();
      } else {
        next('/tecm-sim-exp'); // Corrigido para não causar loop
      }
    }
  },
  {
    path: '/tecm-sim-exp-questions-quiz',
    name: 'TECMQuestionQuizSimuladoLanding',
    component: TECMQuestionQuizSimuladoLanding,
  },
  {
    path: '/',
    name: 'Login',
    component: Login,
  },
  {
    path: '/webapp/questions',
    redirect: '/webapp/questionsupdatedSup'
  },
  {
    path: '/webapp/questionsv2',
    redirect: '/webapp/questionsupdatedSup'
  },
  {
    path: '/webapp',
    name: 'WebApp',
    component: WebApp,
    beforeEnter: authGuard,
    children: [
      {
        path: 'home',
        component: Decks
      },
      {
        path: 'decks',
        component: Decks
      },
      {
        path: 'decksv2',
        name: 'DecksV2',
        component: DecksV2
      },
      {
        path: 'decks2',
        redirect: '/webapp/decksv2'
      },
      {
        path: 'questionsv2',
        component: Questions
      },
      {
        path: 'questionsupdated',
        component: QuestionsUpdated
      },
      {
        path: 'questionsupdatedsup',
        component: QuestionsUpdatedSup
      },
      {
        path: 'questionssimulado',
        component: QuestionsSimulado
      },
      {
        path: 'questionschallenge',
        component: QuestionsChallenge
      },
      {
        path: 'questionsquiz',
        name: 'QuestionsQuiz', // Certifique-se de que o nome está igual ao usado no redirecionamento
        component: QuestionsQuiz
      },
      {
        path: 'questionsquizsimulado',
        name: 'QuestionsQuizSimulado', // Certifique-se de que o nome está igual ao usado no redirecionamento
        component: QuestionsQuizSimulado
      },
      {
        path: 'questionsquizsimuladopratico',
        name: 'QuestionsQuizSimuladoPratico', // Certifique-se de que o nome está igual ao usado no redirecionamento
        component: QuestionsQuizSimuladoPratico
      },
      {
        path: 'questionsquizchallenge',
        name: 'QuestionsQuizChallenge', // Certifique-se de que o nome está igual ao usado no redirecionamento
        component: QuestionsQuizChallenge
      },
      {
        path: 'questionsresults',
        component: QuestionsResults
      },
      {
        path: 'questionsresultssup',
        component: QuestionsResultsSup
      },
      {
        path: 'simuladosresults',
        component: SimuladosResults
      },
      {
        path: 'questionsanswers',
        component: QuestionsAnswers
      },
      {
        path: 'questionsanswerschallenge',
        name: 'QuestionsAnswersChallenge', // Certifique-se de que o nome está igual ao usado no redirecionamento
        component: QuestionsAnswersChallenge
      },
      {
        path: 'questionsadmin',
        component: QuestionsAdmin
      },
      {
        path: 'consolidatedmetrics',
        name: 'ConsolidatedMetrics',
        component: ConsolidatedMetrics
      },
      {
        path: 'about',
        component: AboutView
      },
      {
        path: 'profile',
        component: Profile
      },
      {
        path: 'flashcards',
        component: FlashCards
      },
      {
        path: 'flashcardsv2',
        name: 'FlashCardsV2',
        component: FlashCardsV2
      },
      {
        path: 'flashcards2',
        redirect: '/webapp/flashcardsv2'
      },
      {
        path: 'results',
        component: Results
      },
      {
        path: 'resultsv2',
        name: 'ResultsV2',
        component: ResultsV2
      },
      {
        path: 'results2',
        redirect: '/webapp/resultsv2'
      },
      {
        path: 'quizresults',
        name: 'QuizResults', // Adicione um nome para a rota
        component: QuizResults,
        props: (route) => ({ questions: route.query.questions ? JSON.parse(route.query.questions) : [] }),
      },
    ]
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  base: process.env.BASE_URL,
  routes
})

// Adicionar o navigation guard para revalidar o token antes de cada navegação
router.beforeEach(async (to, from, next) => {
  // Verifica se a rota de destino é livre de autenticação
  if (to.path === '/' || to.path === '/simulados-landing' || to.path === '/simulados-landing-questions' || to.path === '/tecm-sim-exp' || to.path === '/tecm-sim-exp-questions' || to.path === '/tecm-sim-exp-questions-quiz') {
    return next(); // Permite o acesso sem revalidar o token
  }

  try {
    // Tenta revalidar o token antes de permitir a navegação
    await store.dispatch('revalidateToken');
    next(); // Se a revalidação for bem-sucedida, permite a navegação
  } catch (error) {
    console.error('Erro ao revalidar o token:', error);
    // Redireciona para a página de login se o token for inválido
    next({
      path: '/',
      query: { redirect: to.fullPath } // Mantém a página que o usuário queria acessar
    });
  }
});

export default router
